import type { SummaryResource, CommunicationStyle } from "@octopusdeploy/octopus-server-client";
import { CommunicationStyleValues } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import { useEffect, useState } from "react";
import { MachinesContentRow } from "~/areas/infrastructure/components/InfrastructureDashboard/MachinesCard/MachinesContentRow";
import type { EndpointRegistration } from "~/areas/infrastructure/components/MachineSettings/Endpoints/endpointRegistry";
import endpointRegistry from "~/areas/infrastructure/components/MachineSettings/Endpoints/endpointRegistry";
import type { DoBusyTask } from "~/components/DataBaseComponent";
import styles from "../style.module.less";
interface WorkerContentProps {
    summaryResource: SummaryResource;
    link: (obj: WorkerContentFilter) => LinkHref;
    doBusyTask: DoBusyTask;
}
export interface WorkerContentFilter {
    commStyles?: CommunicationStyle[];
}
export const WorkerContent = ({ summaryResource, link, doBusyTask }: WorkerContentProps) => {
    const [registrations, setRegistrations] = useState<EndpointRegistration[]>([]);
    useEffect(() => {
        (async () => {
            await doBusyTask(async () => {
                const loadedRegistrations = await endpointRegistry.getAllRegistrations();
                setRegistrations(loadedRegistrations);
            });
        })();
    }, [doBusyTask]);
    return (<>
            {registrations?.length > 0 && (<div className={styles.cardContentContainerRows}>
                    {Object.keys(summaryResource.MachineEndpointSummaries).map((keyString) => {
                const registration = registrations.find((r) => r.key === keyString);
                if (registration?.communicationStyle !== CommunicationStyleValues.StepPackage)
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    return <MachinesContentRow key={keyString} deploymentTargetType={keyString} link={(commStyle) => link({ commStyles: [commStyle as CommunicationStyle] })} summaries={summaryResource.MachineEndpointSummaries}/>;
            })}
                </div>)}
        </>);
};
